import React from "react";

import { SideNavBar, SideNavBarV2 } from "../../components";
import { tabs } from "./helper";

const ShippingNav = ({ value = 1, setValue = () => {} }) => {
  const props = { tabs, value, setValue };
  return <SideNavBarV2 {...props} />;
};

export default ShippingNav;
